import { CookieNamesEnum } from '@/enums/CookieNamesEnum'
import { getCookie } from '@/helpers/getCookie'

import type { AsmSession } from '@/interfaces/AsmSession'

/** A malformed cookie counts as no ASM session, so it cannot crash the page that reads it. */
export const getAsmSession = (serverCookies?: string): AsmSession | undefined => {
  const cookieValue = getCookie(CookieNamesEnum.AsmSession, serverCookies)

  if (!cookieValue) {
    return undefined
  }

  try {
    return JSON.parse(cookieValue) as AsmSession
  } catch {
    return undefined
  }
}
